module.exports = __webpack_public_path__ + "img/tflogo.6270ed5c.png";